import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { OtpRequestPayload } from '../models/payload/auth';
import { OptRequestResponse } from '../models/response/auth';
import { sendCode } from '../services/auth';
import { createAppAsyncThunk } from '../utils/reduxUtil';

interface OtpStateStructure {
  loading: boolean;
  userId: string | undefined;
  isRegistered: boolean;
  phoneNumber: string | undefined | null;
}

const initialState: OtpStateStructure = {
  loading: false,
  userId: undefined,
  isRegistered: false,
  phoneNumber: undefined,
};

const sendOtpForUser = createAppAsyncThunk<OptRequestResponse, OtpRequestPayload>(
  'otp/sendOtpForUser',
  async (payload: OtpRequestPayload) => {
    const response = await sendCode(payload);
    return response;
  }
);

const otpSlice = createSlice({
  name: 'otp',
  initialState,
  reducers: {
    clearUserId: (state) => ({ ...state, userId: undefined }),
  },
  extraReducers: (builder: ActionReducerMapBuilder<OtpStateStructure>) => {
    builder.addCase(sendOtpForUser.pending, (state) => ({ ...state, loading: true }));
    builder.addCase(sendOtpForUser.fulfilled, (state, action) => ({
      ...state,
      loading: false,
      userId: action?.payload?.data?.id,
      isRegistered: Boolean(action?.payload?.data?.isRegistered),
      phoneNumber: action?.payload?.data?.phoneNumber,
    }));
    builder.addCase(sendOtpForUser.rejected, (state) => ({ ...state, loading: false }));
  },
});

export default otpSlice;
export { sendOtpForUser };
